export default [
  // {
  //   header: "راهنما های گام به گام انواع تبلیغات",
  //   links: [
  //     {
  //       title: "راهنمای گام به گام تبلیغات بنری موضوعی",
  //       href: "/help/step-by-step-create-campaign-banner",
  //     },
  //     {
  //       title: "راهنمای گام به گام تبلیغات بنری ریتارگتینگ",
  //       href: "#",
  //     },
  //     {
  //       title: "راهنمای گام به گام تبلیغات بنری موضوعی + کلیدواژه‌ای",
  //       href: "#",
  //     },
  //   ],
  // },
  {
    header: "مدیریت مالی حساب های کاربری",
    links: [
      {
        title: "راهنمای دریافت فاکتور رسمی",
        href: "#",
      },
      {
        title: "چگونگی تبدیل هایکون به تومان",
        href: "#",
      },
      {
        title: "تسویه حساب ناشران",
        href: "#",
      },
      {
        title: "دریافت تخفیف حمایتی از هایلات",
        href: "#",
      },
    ],
  },
  {
    header: "آشنایی با هایلات",
    links: [
      {
        title: "واژه نامه هایلات",
        href: "#",
      },
      {
        title: "قیمت گذاری و تعرفه ها",
        href: "#",
      },
      {
        title: "انواع کمپین ها",
        href: "#",
      },
    ],
  },
];
